module.exports = __webpack_public_path__ + "img/ridgeline-21.e6d4e037.png";